import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Lightweight app-wide event bus for cross-cutting signals that don't belong
 * to a single feature module. Angular-native replacement for the piece of
 * Consumer's bootstrap (`AuthHydrator` in app/providers.tsx) that called
 * React Query's `invalidateAllQueries()` when the tab regains focus after
 * being hidden.
 *
 * This app doesn't have (or need) a global server-cache library the way
 * Consumer uses TanStack Query — each screen's repository fetches on its own
 * lifecycle instead. So rather than force-fit a global cache-invalidation
 * call, `foregroundDataRefresh$` is emitted on the same trigger (tab becomes
 * visible again while authenticated) and any screen that wants "refetch when
 * the user comes back to this tab" behavior (the dashboard's provisioning
 * status is the main candidate) can subscribe to it — same effect, achieved
 * the idiomatic Angular way instead of copying a React-Query-specific API.
 */
@Injectable({ providedIn: 'root' })
export class AppEventsService {
  private readonly foregroundRefreshSubject = new Subject<void>();
  readonly foregroundDataRefresh$ = this.foregroundRefreshSubject.asObservable();

  emitForegroundDataRefresh(): void {
    this.foregroundRefreshSubject.next();
  }
}
